export const BREAKPOINTS = {
	mobile: 480,
	tablet: 768,
	desktop: 1000,
	wide: 1300,
};

export const mediaUp = (bp) => `@media (min-width: ${bp}px)`;

export const mediaDown = (bp) => `@media (max-width: ${bp}px)`;
